import { action, computed, observable } from 'mobx';
import { setter, toggle } from 'mobx-decorators';
import { concatDeserializeMappers, deserializeWithMappers, setFieldValues } from 'stores/Utils';
import BaseBlockStore from '../BaseBlockStore';
import constants from 'Constants';

class HtmlBlockStore extends BaseBlockStore {

  @setter @observable code;

  static create(data={}) {
    const instance = new HtmlBlockStore();
    setFieldValues(instance, data);
    return instance;
  }

  static getDefaults() {
    return Object.assign({}, BaseBlockStore.getDefaults(), {
      "code": "",
    });
  }

  constructor(defaults=HtmlBlockStore.getDefaults()) {
    super(defaults);
  }

  reset(defaults=HtmlBlockStore.getDefaults()) {
    super.reset(defaults);
  }

  getDeserializeMappers() {
    let mappers = [
      {"field": "code"},
    ];

    return concatDeserializeMappers(super.getDeserializeMappers(), mappers);
  }

  @action async deserialize(data) {
    await deserializeWithMappers(this, this.getDeserializeMappers(), data);
  }

}


export default HtmlBlockStore;
